import { amPalette, AmPalette } from './am-palette';
import { cosmicPalette, CosmicPalette } from './cosmic-palette';
import { edisonPalette, EdisonPalette } from './edison-palette';
import { einsteinPalette, EinsteinPalette } from './einstein-palette';
import { gammaPalette, GammaPalette } from './gamma-palette';
import { infraredPalette, InfraredPalette } from './infrared-palette';
import { opticPalette, OpticPalette } from './optic-palette';
import { phosphatePalette, PhosphatePalette } from './phosphate-palette';
import { prismPalette, PrismPalette } from './prism-palette';
import { radarPalette, RadarPalette } from './radar-palette';
import { ultravioletPalette, UltravioletPalette } from './ultraviolet-palette';

export { primaryPalette } from './primary-palette';
export { tempusPalette } from './tempus-palette';
export { grayPalette } from './gray-palette';

// This empty interface gets us all the documentation declared in each palette module.
// Doesn't seem to work if you define it as a union type.
interface FullPalette
  extends AmPalette,
    CosmicPalette,
    EdisonPalette,
    EinsteinPalette,
    GammaPalette,
    InfraredPalette,
    OpticPalette,
    PhosphatePalette,
    PrismPalette,
    RadarPalette,
    UltravioletPalette {}

export const fullPalette: FullPalette = {
  ...amPalette,
  ...cosmicPalette,
  ...edisonPalette,
  ...einsteinPalette,
  ...gammaPalette,
  ...infraredPalette,
  ...opticPalette,
  ...phosphatePalette,
  ...prismPalette,
  ...radarPalette,
  ...ultravioletPalette,
};
